"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FidContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Spectrum2D_1 = require("../../../data/data2d/Spectrum2D");
const MouseTracker_1 = require("../../EventsTrackers/MouseTracker");
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const HorizontalSliceChart_1 = __importDefault(require("../1d-tracer/HorizontalSliceChart"));
const VerticalSliceChart_1 = __importDefault(require("../1d-tracer/VerticalSliceChart"));
const scale_1 = require("../utilities/scale");
const FidCanvas_1 = require("./FidCanvas");
function FidContainer() {
    const spectrum = (0, useSpectrum_1.default)();
    if (!spectrum || spectrum?.info?.isFt)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TrackerContainer, {}), (0, jsx_runtime_1.jsx)(FidCanvas_1.FidCanvas, {})] }));
}
exports.FidContainer = FidContainer;
function TrackerContainer() {
    const spectrum = (0, useSpectrum_1.default)();
    const scale2dX = (0, scale_1.useScale2DX)();
    const scale2dY = (0, scale_1.useScale2DY)();
    const position = (0, MouseTracker_1.useMouseTracker)();
    if (!position || !spectrum || spectrum?.info?.isFt)
        return null;
    const { x, y } = position;
    const data = (0, Spectrum2D_1.getSlice)(spectrum, {
        x: scale2dX.invert(x),
        y: scale2dY.invert(y),
    });
    if (!data)
        return null;
    return ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)(HorizontalSliceChart_1.default, { data: data.horizontal.data, reverse: true }), (0, jsx_runtime_1.jsx)(VerticalSliceChart_1.default, { data: data.vertical.data })] }));
}
